import { Link } from "@tanstack/react-router";

export function CTASection({
  title = "Conteúdo estratégico para líderes",
  text = "Artigos, análises e guias sobre liderança, gestão e empreendedorismo — publicados semanalmente pelo time editorial da Liderança com Valores.",
  buttonLabel = "Ler os artigos",
}: {
  title?: string;
  text?: string;
  buttonLabel?: string;
}) {
  return (
    <section className="py-16 md:py-20">
      <div className="container-svg">
        <div className="relative overflow-hidden rounded-lg border border-border bg-foreground text-background p-8 md:p-14">
          <div className="relative max-w-2xl">
            <span className="inline-block rounded bg-background/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.15em] text-background/80">Newsletter</span>
            <h2 className="mt-4 text-3xl font-bold tracking-tight md:text-4xl text-background">{title}</h2>
            <p className="mt-4 text-base text-background/80 md:text-lg">{text}</p>
            <div className="mt-8">
              <Link to="/blog" className="inline-flex items-center gap-2 rounded-md bg-background px-5 py-3 text-sm font-semibold text-foreground hover:bg-background/90 transition">{buttonLabel}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
